import { z } from "zod";
import { Phase1CheckResultV1Schema } from "./phase1-check-result.js";
export const LANGUAGE_HYGIENE_CHECK_ID = "surface-quality.language-hygiene";
export const LanguageHygieneCheckResultV1Schema = Phase1CheckResultV1Schema.extend({
    checkId: z.literal(LANGUAGE_HYGIENE_CHECK_ID),
});
export const LanguageHygieneEvaluatorInputSchema = z
    .object({
    visibleText: z.string(),
})
    .strict();
//# sourceMappingURL=language-hygiene-check-result.js.map